module.exports = __webpack_public_path__ + "fonts/Lato-300-latin-ext3.577577e.woff2";